export class ApplicationV2Api {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async editPropertyRelated({ withLoanOptionId, applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/property-related`, body, {
      params: { withLoanOptionId },
    });
  }

  async editLockLoanInfo({ withLoanOptionId, applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/lock-loan`, body, {
      params: { withLoanOptionId },
    });
  }

  async editLoanRelatedV2({ withLoanOptionId, applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/loan-related/v2`, body, {
      params: { withLoanOptionId },
    });
  }

  async editRateSheet({ withLoanOptionId, applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/rate-sheet`, body, {
      params: { withLoanOptionId },
    });
  }

  async editLoanInfo({ withLoanOptionId, applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/loan-info`, body, {
      params: { withLoanOptionId },
    });
  }

  async getRelatedLoans({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/related-loans`);
  }
}
